<template>
  <mcw-dialog
    class="service-selector-dialog"
    ref="dialogRef"
    v-model="modalOpen"
    scrollable
  >
    <mcw-dialog-title>
      <span>Перечень услуг</span>
      <span>
        <mcw-material-icon
          @click="modalOpen = false;"
          icon="cancel"
        />
      </span>
    </mcw-dialog-title>

    <mcw-dialog-content>
      <mcw-circular-progress
        v-if="!hazardServices.length && processing"
        indeterminate
        density="-8"
        style="width:50px;height:50px"
      />
      <section v-else>
        <div class="hazard-services-select">
          <mcw-textfield
            outlined
            label="Добавить услуги"
            v-model="searchService"
            @click="menuOpen = true"
            @blur="menuOpen = false"
          />
          <div
            v-if="menuOpen && filteredServices.length"
            class="custom-menu"
            @mousedown.prevent
          >
            <ul class="custom-list">
              <li
                v-for="opt in filteredServices"
                :key="opt.id_service"
                class="custom-list-item"
                :class="{
                  'already-selected': isAlreadySelected(opt),
                  'is-loading': serviceProcessing.includes(opt.id_service)
                }"
                @click="tryAddService(opt)"
              >
                <div class="item-content">
                  <span class="service-name">{{ formatName(opt.short_name) }}</span>
                  <small v-if="userRank >= 100">{{ opt.price }}₽</small>
                </div>
                <mcw-circular-progress
                  v-if="serviceProcessing.includes(opt.id_service)"
                  indeterminate
                  density="-8"
                />
              </li>
            </ul>
          </div>
        </div>

        <mcw-list two-line class="hazard-services-list">
          <mcw-list-item
            v-for="service in selectedServices"
            :key="service.id_service"
            :class="{ 'temp-service': service.is_temp }"
            class="selected-services-list"
          >
            <section class="service-item">
              <span class="service-name">
                {{ formatName(service.short_name) }}
              </span>
              <span
                class="mdc-list-item__secondary-text"
                v-if="userRank >= 100"
                style="display:flex;align-items:center;"
              >
                <span>{{ service.price }}</span>
                <mcw-material-icon icon="currency_ruble" class="currency-icon" />
              </span>
            </section>

            <template v-if="!service.obligatory">
              <mcw-circular-progress
                v-if="serviceProcessing.includes(service.id_service)"
                indeterminate
                density="-5"
              />
              <mcw-material-icon
                v-else
                @click="onRemoveService(service)"
                icon="cancel"
                class="delete-icon"
              />
            </template>
          </mcw-list-item>
        </mcw-list>
      </section>
    </mcw-dialog-content>

    <mcw-dialog-footer>
      <mcw-button @click="close" style="margin-right: 0.75rem;">Отмена</mcw-button>
      <mcw-button @click="confirm" raised>
        <mcw-material-icon icon="check" style="color: #fff; margin-right:0.25rem;"/>
        Подтвердить
      </mcw-button>
    </mcw-dialog-footer>
  </mcw-dialog>
</template>

<script>
export default {
  props: ['id_patient'],
  emits: ['close'],
  data() {
    return {
      selectedServices: [],
      searchService: '',
      menuOpen: false,
      modalOpen: false,
      serviceProcessing: [],
      processing: false,
      inputEl: null,
      hazardServices: [],
    };
  },
  async mounted() {
    this.menuOpen = false;
    await this.refreshServices();
    this.$nextTick(() => {
      this.inputEl = this.$el.querySelector('.mdc-text-field__input');
    });
  },
  watch: {
    modalOpen(val) {
      if (val && this.inputEl) {
        setTimeout(() => {
          this.inputEl.blur();
        }, 500);
      }
    },
  },
  computed: {
    filteredServices() {
      const query = this.searchService.toLowerCase();
      return this.hazardServices.filter((s) => JSON.stringify(s).toLowerCase().includes(query));
    },
    userRank() {
      return this.$store.getters['user/getUserRank'];
    },
  },
  methods: {
    formatName(name) {
      return name.replace(/\s*([,.!?:;]+)(?!\s*$)\s*/g, '$1 ');
    },
    isAlreadySelected(service) {
      return this.selectedServices.some((s) => s.id_service === service.id_service);
    },
    async refreshServices() {
      await this.getHazardServices(this.id_patient);
      this.selectedServices = this.hazardServices.filter((s) => s.in_patient || s.is_temp);
    },
    async tryAddService(service) {
      if (this.isAlreadySelected(service)) return;
      if (this.serviceProcessing.includes(service.id_service)) return;

      this.serviceProcessing.push(service.id_service);
      const res = await this.addTmpService(service.id_service);
      if (res) await this.refreshServices();
      if (typeof res === 'string') {
        this.emitter.emit('message', res);
      }

      const i = this.serviceProcessing.indexOf(service.id_service);
      if (i > -1) this.serviceProcessing.splice(i, 1);
    },
    async onRemoveService(service) {
      if (this.serviceProcessing.includes(service.id_service)) return;

      this.serviceProcessing.push(service.id_service);
      const res = await this.removeTmpService(service.id_service);
      if (res) await this.refreshServices();
      if (typeof res === 'string') {
        this.emitter.emit('message', res);
      }
      const i = this.serviceProcessing.indexOf(service.id_service);
      if (i > -1) this.serviceProcessing.splice(i, 1);
    },
    async confirm() {
      const hasTemp = this.selectedServices.some((s) => s.is_temp);
      if (hasTemp) {
        const res = await this.appendTmpServices();
        if (typeof res === 'string') {
          this.emitter.emit('message', res);
          return;
        }
      }
      this.close();
    },
    close() {
      this.modalOpen = false;
      this.$emit('close');
    },
    open() {
      this.modalOpen = true;
    },
    async addTmpService(service) {
      const result = await this.$store.dispatch('employeesData/addTmpService', {
        id_patient: this.id_patient, id_sevice: service,
      });
      return result;
    },
    async getHazardServices() {
      try {
        this.processing = true;
        this.hazardServices = await this.$store.dispatch('employeesData/getHazardServices', { id_patient: this.id_patient });
      } catch (err) {
        console.error(err);
      } finally {
        this.processing = false;
      }
    },
    async removeTmpService(service) {
      const result = await this.$store.dispatch('employeesData/removeTmpService', {
        id_patient: this.id_patient, id_sevice: service,
      });
      return result;
    },
    async appendTmpServices() {
      const result = await this.$store.dispatch('employeesData/appendTmpServices', this.id_patient);
      return result;
    },
  },
};
</script>

<style>
.service-selector-dialog .mdc-dialog__surface {
  max-width: 700px !important;
  min-width: 400px !important;
}
.service-selector-dialog .mdc-list-item__text {
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  padding: 0 8px !important;
}
.mdc-list-item.selected-services-list:nth-child(even) {
  background-color: #f1f1f1a1;;
}
.service-selector-dialog .mdc-circular-progress {
  width: 30px !important;
  height: 30px !important;
}
</style>

<style scoped>
.mdc-dialog__title {
  padding-top: 1rem;
}
.service-name {
  white-space: normal;
  max-width: 90%;
}
.selected-services-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.service-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.temp-service {
  background-color: #e3f2fd !important;
}
.currency-icon {
  font-size: 0.8rem;
}
.delete-icon {
  color: #d32f2f;
  cursor: pointer;
}
.already-selected {
  background-color: #e8f5e9;
  color: #4caf50;
}
.is-loading {
  opacity: 0.5;
  pointer-events: none;
}
.hazard-services-select {
  position: relative;
}
.hazard-services-list {
  overflow: scroll;
  height: 65vh;
}
.custom-menu {
  position: absolute;
  z-index: 2;
  width: 100%;
  max-height: 500px;
  overflow: scroll;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.custom-list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

.custom-list-item {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.2s;
}

.custom-list-item:hover {
  background: #f1f1f1;
}

.item-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.already-selected {
  background-color: #e8f5e9;
  color: #4caf50;
  pointer-events: none;
}

.is-loading {
  opacity: 0.6;
  pointer-events: none;
}

</style>
